@if (!!content?.background) {
  <sd-banner
    [media]="content?.background"
    [isComponentLoading]="isLoading"
    class="c__component-wrapper-background"
  />
}

<div class="c__component-wrapper-wrapper">
  <div class="c__component-wrapper-editorial">
    @if ((content?.heading && !hasNoData) || (content?.links?.length && layout === orientationEnum.row)) {
      @if (content?.heading && !hasNoData) {
        <sd-heading
          [isLoading]="isLoading"
          (noData)="checkData($event)"
          [parentsThemesConfig]="themesConfig"
          [textConfig]="textConfig"
          [heading]="content?.heading?.data"
          [limit]="content?.heading?.limit"
          [titleThemesConfig]="content?.heading?.titleThemesConfig"
          [readMore]="content?.heading?.readMore"
          [iconSize]="content?.heading?.iconSize"
          [iconNameOpened]="content?.heading?.iconNameOpened"
          [iconNameClosed]="content?.heading?.iconNameClosed"
          [idReadMore]="content?.heading?.idReadMore"
          [isUnderlined]="content?.heading?.isUnderlined"
          [isDescription]="content?.heading?.isDescription"
          [titleLevel]="content?.heading?.titleLevel || titleLevel"
          [size]="content?.heading?.size"
        />
      }
      @if (!isLoading) {
        <ng-container *ngTemplateOutlet="componentActions" />
      }
    }

    @if (content?.footNotes?.length) {
      <div class="c__component-wrapper-footnotes">
        <sd-footnote
          [isLoading]="isLoading"
          [footNotes]="content?.footNotes"
          [parentsThemesConfig]="themesConfig"
          [textConfig]="textConfig"
        />
      </div>
    }
  </div>

  @if (!emptyComponent) {
    <div #componentWrapper class="c__component-wrapper-component {{componentWidth ? componentWidth : ''}}">
      <ng-content select="[sd-component-wrapper-component]" />
    </div>
  }
</div>

<ng-template #componentActions>
  @if (content?.links?.length) {
    <div class="c__component-wrapper-actions">
      @for (link of content?.links; track link) {
        @if (link?.linkName) {
          <sd-link
            [link]="link"
            [brand]="brand"
            [isButton]="true"
            [theme]="link?.theme"
            (clicked)="onClickLink(link)"
            [isSecondary]="themesConfig === brandThemesEnum.brand ? true : link?.border"
          >
            <span>{{link?.linkName}}</span>
          </sd-link>
        }
      }
    </div>
  }
</ng-template>
